jQuery(document).ready(function ($) {
  
  
    if ($(document).scrollTop() >= 25) {
      $('header.header').addClass('js-scrolling');
    } else {
      $('header.header').removeClass('js-scrolling');
    }
    $(document).scroll(function() {
          if ($(document).scrollTop() >= 25) {
            $('header.header').addClass('js-scrolling');
          } else {
            $('header.header').removeClass('js-scrolling');
          }
    });
 
    

   $(".is-dropdown-submenu-parent a").on("click touchstart", function(){
     console.log('click');
     
    $("header.header").addClass("active"); 
    
    //make parent menu item clickable after dropdown is active
    $(this).click(function(){
      console.log('this');
      if($(this).parent().hasClass('is-dropdown-submenu-parent')) {
      window.location = $(this).attr('href');
      }
      
    });
    
});

$(".page-template-container").click(function(){
  $("header.header").removeClass("active");
});

   




});